import React from 'react';
import { useNavigate } from 'react-router-dom';
import './card3.css';
import ButtonHome from '../ButtonHome';
import mulherImg from '../../assets/mulherfundo.jpg';

const Card3 = () => {
  const navigate = useNavigate();
  return (
    <section className="c3-section">
      <div className="c3-layout">
        
        {/* Lado Esquerdo: Stage com Efeito do Card2 */}
        <div className="c3-visual-left">
          <div className="c3-center-stage">
            <div className="c3-glass-plate"></div>
            <img 
              src={mulherImg} 
              alt="Estudante comemorando" 
              className="c3-person-img"
            />
          </div>
        </div>

        {/* Lado Direito: Conteúdo */}
        <div className="c3-content-right">
          <h2 className="c3-main-title">
            Perdendo dinheiro pagando inteira? <br />
            Curta o dobro pagando metade!
          </h2>
          <p className="c3-sub">Confira alguns dos benefícios:</p>

          <div className="c3-grid-benefits">
            <div className="c3-benefit-card">
              <span className="c3-emoji"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-film-icon lucide-film"><rect width="18" height="18" x="3" y="3" rx="2"/><path d="M7 3v18"/><path d="M3 7.5h4"/><path d="M3 12h18"/><path d="M3 16.5h4"/><path d="M17 3v18"/><path d="M17 7.5h4"/><path d="M17 16.5h4"/></svg></span>
              <div className="c3-txt">
                <h4>Cinema</h4>
                <p>Aproveite para ver as estrelas pagando meia.</p>
              </div>
            </div>

            <div className="c3-benefit-card">
              <span className="c3-emoji"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-volleyball-icon lucide-volleyball"><path d="M11.1 7.1a16.55 16.55 0 0 1 10.9 4"/><path d="M12 12a12.6 12.6 0 0 1-8.7 5"/><path d="M16.8 13.6a16.55 16.55 0 0 1-9 7.5"/><path d="M20.7 17a12.8 12.8 0 0 0-8.7-5 13.3 13.3 0 0 1 0-10"/><path d="M6.3 3.8a16.55 16.55 0 0 0 1.9 11.5"/><circle cx="12" cy="12" r="10"/></svg></span>
              <div className="c3-txt">
                <h4>Estádio</h4>
                <p>Curta seu time do coração pagando meia.</p>
              </div>
            </div>

            <div className="c3-benefit-card">
              <span className="c3-emoji"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-music-icon lucide-music"><path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/></svg></span>
              <div className="c3-txt">
                <h4>Shows</h4>
                <p>Vá curtir sua banda favorita pagando meia.</p>
              </div>
            </div>

            <div className="c3-benefit-card">
              <span className="c3-emoji"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-drama-icon lucide-drama"><path d="M10 11h.01"/><path d="M14 6h.01"/><path d="M18 6h.01"/><path d="M6.5 13.1h.01"/><path d="M22 5c0 9-4 12-6 12s-6-3-6-12c0-2 2-3 6-3s6 1 6 3"/><path d="M17.4 9.9c-.8.8-2 .8-2.8 0"/><path d="M10.1 7.1C9 7.2 7.7 7.7 6 8.6c-3.5 2-4.7 3.9-3.7 5.6 4.5 7.8 9.5 8.4 11.2 7.4.9-.5 1.9-2.1 1.9-4.7"/><path d="M9.1 16.5c.3-1.1 1.4-1.7 2.4-1.4"/></svg></span>
              <div className="c3-txt">
                <h4>Espetáculos</h4>
                <p>Muita cultura por metade do preço.</p>
              </div>
            </div>
          </div>

          <ButtonHome onClick={() => navigate('/login')} text={'Faça agora a sua carteirinha'} />
        </div>

      </div>
    </section>
  );
};

export default Card3;